<svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M18.125 9.35264L12.5021 14.6473L6.87401 9.35264"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="square"
    />
</svg>
